import React from 'react'
import styles from './index.module.scss'
import { Check } from '../../../../../assets/NewDashboard'

const ResultsFooter = ({ missingDisciplines }) => {
  return (
    <div className={styles.footer}>
      <div className={styles.footerItem}>
        <Check mode="complete" />
        <span>Объём обязательной части программы:</span>
        <strong>150 з.е.</strong>
      </div>
      {missingDisciplines.length > 0 && (
        <div className={styles.footerItem}>
          <Check mode="notComplete" />
          <span>Согласно ФГОС не хватает дисциплин:</span>
          <div className={styles.missingList}>
            {missingDisciplines.map((item, idx) => (
              <div key={idx}>{item.course_name}</div>
            ))}
          </div>
        </div>
      )}
    </div>
  )
}

export default ResultsFooter
